import React, { useEffect, useState } from "react";
import { Sliders } from "react-feather";
import { useSpace } from "../../contexts/SpaceContext";

const useDashboardItems = () => {
  const { spaces, currentSpace, loading, changeSpace } = useSpace();

  // Create sidebar items based on spaces
  const navItems = [
    {
      title: "Spaces",
      pages: spaces.map((space) => ({
        href: `/spaces/${space.id}`,
        icon: Sliders,
        title: space.name,
        // Add a isActive property to highlight the current space
        isActive: currentSpace?.id === space.id,
        // Add onClick handler to change space when clicked
        onClick: () => changeSpace(space.id),
      })),
    },
  ];

  return navItems;
};

export default useDashboardItems;
